import { Routes } from "@angular/router";
import { ProductsListingComponent } from "./components/products-listing/products-listing.component";

export const productsRoutes: Routes = [
  { path: "", component: ProductsListingComponent },
];
